module.exports = __webpack_public_path__ + "static/media/dave.7ed1158f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dave.webp
// module id = 91
// module chunks = 0